/**
 * FireFox raises keyPress event even on "Del" and other keys
 * It's the list of these keys
 */

export class keyPressServiceKeys {
    private static keyPressServiceKeys: Array<string> = [
        'ArrowLeft',
        'ArrowUp',
        'ArrowRight',
        'ArrowDown',
        'Backspace',
        'Delete',
        'Home',
        'End',
        'Enter',
        'Tab'
    ];

    public static contains(s: string): boolean {
        return this.keyPressServiceKeys.some(x => x == s);
    }
}
